const REMEMBERED_EMAIL_KEY = "rememberedLoginEmail";

export function getRememberedEmail() {
  try {
    return localStorage.getItem(REMEMBERED_EMAIL_KEY) || "";
  } catch {
    return "";
  }
}

// Passwords are handled by the browser's password manager, never app storage.
export function rememberEmail(email, enabled) {
  try {
    if (enabled && email.trim()) {
      localStorage.setItem(REMEMBERED_EMAIL_KEY, email.trim());
    } else {
      localStorage.removeItem(REMEMBERED_EMAIL_KEY);
    }
  } catch {
    // Remembering an email is optional when browser storage is unavailable.
  }
}

export function clearStoragePreservingRememberedEmail() {
  const email = getRememberedEmail();
  localStorage.clear();
  if (email) rememberEmail(email, true);
}
